<div class="modal-overlay" *ngIf="isOpen" (click)="closeModal()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <!-- Empty header with background -->
    </div>

    <!-- Modal Content -->
    <div class="modal-content">
      <!-- Illustration and Timer -->
      <div class="illustration-section">
        <!-- Payment Link Illustration -->
        <div class="illustration">
          <img src="assets/images/payment-link-sent/payment-link-illustration.svg" 
               alt="Payment Link Sent" 
               width="180" 
               height="180">
        </div>

        <!-- Timer -->
        <div class="timer-container">
          <div class="timer-box">
            <div class="timer-section">
              <div class="timer-number">{{ formattedMinutes }}</div>
              <div class="timer-label">Minutes</div>
            </div>
            <div class="timer-section">
              <div class="timer-number">{{ formattedSeconds }}</div>
              <div class="timer-label">Seconds</div>
            </div>
            <div class="timer-separator">:</div>
          </div>
        </div>
      </div>

      <!-- Text Content -->
      <div class="text-section">
        <div class="text-content">
          <h2 class="modal-title">Payment link has been sent!</h2>
          <p class="modal-description">
            Payment link sent to {{ formattedPhoneNumber }}. Awaiting customer action.
          </p>
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <div class="button-container">
        <div class="button-group">
          <button class="btn-primary" 
                  (click)="onResendLink()" 
                  [disabled]="isResending">
            <span *ngIf="!isResending">Resend Link</span>
            <span *ngIf="isResending" class="loading-content">
              <div class="loading-spinner"></div>
              Sending...
            </span>
          </button>
          <button class="btn-secondary" (click)="onCancelPayment()">
            Cancel Payment
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
